import { trackEvent } from './analytics';

/**
 * MCP connect funnel (CEL-3365, Oct 9 2026). One event name, `mcp_connect_step`, with `step` =
 * request_started · account_created · email_verified · terms_step_1..5 · approved · cancelled ·
 * expired_or_answered. Funnels read unique people, so a step fired from two tabs counts once.
 * The final step (first real use) is not an event: it is the person's first chat whose
 * sdk_client_info.agent_name starts with "mcp:", read from the record.
 */
export const MCP_FUNNEL_EVENT = 'mcp_connect_step';

/** True for the MCP consent page path (/authorize, query allowed). */
export const isMcpAuthorizePath = (path) => typeof path === 'string' && /^\/authorize(\?|#|\/|$)/.test(path);

/** Where a signed-out visitor goes: the MCP consent page sends people to SIGN-UP (most arrivals from an MCP client
 * are new; CEL-3365, Nitish Oct 9 2026). SignUp's "Log in" link carries the same state for existing users. */
export const signedOutTarget = (pathname) => (isMcpAuthorizePath(pathname) ? '/signup' : '/login');

/** "/path?query#hash" from a react-router location (or null). */
export const pathOf = (loc) => (loc?.pathname ? `${loc.pathname}${loc.search || ''}${loc.hash || ''}` : null);

export function trackMcpStep(step, props = {}) {
  trackEvent(MCP_FUNNEL_EVENT, { step, ...props });
}
